import { render, staticRenderFns } from "./PositiveIcon.vue?vue&type=template&id=765cede0&functional=true&"
import script from "./PositiveIcon.vue?vue&type=script&lang=js&"
export * from "./PositiveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports